import { Link } from "react-router-dom";
import { useState } from "react";
import "../styles/navbar.css";
import logo from "../assets/images/logo.jpeg";

export default function Navbar() {
  const [open, setOpen] = useState(false);

  // Close menu when a link is clicked
  const closeMenu = () => setOpen(false);

  return (
    <nav className="navbar">
      {/* Logo */}
      <div className="logo">
        <Link to="/" onClick={closeMenu}>
          <img src={logo} alt="COLIPS FM" />
        </Link>
      </div>

      {/* Hamburger */}
      <button
        className="menu-btn"
        onClick={() => setOpen(!open)}
        aria-label="Toggle menu"
      >
        {open ? "✕" : "☰"}
      </button>

      {/* Navigation */}
      <ul className={open ? "nav active" : "nav"}>

        <li><Link to="/" onClick={closeMenu}>Home</Link></li>
        <li><Link to="/about" onClick={closeMenu}>About Us</Link></li>

        {/* Security Dropdown */}
        <li className="dropdown">
          <span>Security Services</span>
          <ul>
            <li><Link to="/security#door-supervisor" onClick={closeMenu}>Door Supervisor</Link></li>
            <li><Link to="/security#event-security" onClick={closeMenu}>Event Security</Link></li>
            <li><Link to="/security#close-protection" onClick={closeMenu}>Close Protection</Link></li>
            <li><Link to="/security#dog-handler" onClick={closeMenu}>Dog Handler</Link></li>
            <li><Link to="/security#cctv-monitoring" onClick={closeMenu}>CCTV Monitoring</Link></li>
            <li><Link to="/security#vacant-property" onClick={closeMenu}>Vacant Property Management</Link></li>
          </ul>
        </li>

        {/* Facility Dropdown */}
        <li className="dropdown">
          <span>Facility Management</span>
          <ul>
            <li><Link to="/facility#cleaningservices" onClick={closeMenu}>Cleaning Services</Link></li>
            <li><Link to="/facility#eventdecorations" onClick={closeMenu}>Event Decorations</Link></li>
            <li><Link to="/facility#carrental" onClick={closeMenu}>Car Rental</Link></li>
            <li><Link to="/facility#dogwalker" onClick={closeMenu}>Dog Walker</Link></li>
            <li><Link to="/facility#housekeeping" onClick={closeMenu}>House Keeping</Link></li>
          </ul>
        </li>

        <li><Link to="/projects" onClick={closeMenu}>Projects</Link></li>
        <li><Link to="/contact" onClick={closeMenu}>Contact Us</Link></li>

      </ul>
    </nav>
  );
}